import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CustomButton from './CustomButton';

const GoogleFormWrapper = ({
  fields,
  btnName = "Submit",
  formId,
  redirectToWhatsApp,
  whatsappNumber,
  onSuccess,
  toggleModal,
  defaultFields
}) => {
  const [formData, setFormData] = useState(
    fields.reduce((acc, field) => {
      acc[field.name] = '';
      return acc;
    }, {})
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (!name) return;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formUrl = `https://docs.google.com/forms/d/e/${formId}/formResponse`;
    const dataToSend = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      dataToSend.append(key, value);
    });

    Object.entries(defaultFields || {}).forEach(([key, value]) => {
      dataToSend.append(key, value);
    });

    try {
      await fetch(formUrl, {
        method: 'POST',
        mode: 'no-cors',
        body: dataToSend,
      });

      if (redirectToWhatsApp && whatsappNumber) {
        // Build mapping of entryName → fieldName

        // Create message using fieldName instead of entryName
        const message = Object.entries(formData)
          .map(([key, value]) => `${fields.find(u => u.name == key)?.label}: ${value}`)
          .join('\n');

        const encodedMessage = encodeURIComponent(`Hello Datacode, I just submitted the datacode free coding calss form:\n\n${message}`);
        const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
        window.open(whatsappLink, '_blank');
      }
      setFormData(
        fields.reduce((acc, field) => {
          acc[field.name] = '';
          return acc;
        }, {})
      );
      return onSuccess(true)
    } catch (err) {
      console.error('Form submission failed:', err);
      alert('Something went wrong. Please try again.');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        {fields.map((field) => (
          <div
            key={field.name}
            className={`form-group text-left ${field.type === "radio" ? "col-12 my-3" : "col-md-6 col-12 my-2"
              }`}
          >
            <label htmlFor={field.name} className="font-weight-regular">
              {field.label || field.name}
            </label>

            {field.type === "radio" ? (
              <div>
                {field.options.map((option, index) => (
                  <div
                    key={index}
                    className="form-check d-flex align-items-center py-2"
                  >
                    <input
                      type="radio"
                      id={`${field.name}-${option}`}
                      name={field.name}
                      value={option}
                      className="form-control mr-3"
                      checked={formData[field.name] === option}
                      onChange={handleChange}
                      required={field.required}
                      disabled={field.disabled}
                    />
                    <label htmlFor={`${field.name}-${option}`} className="mb-0 lh-0">
                      {option}
                    </label>
                  </div>
                ))}
              </div>
            ) : (
              <input
                type={field.type || "text"}
                id={field.name}
                name={field.name}
                className="form-control py-4 pl-3"
                value={formData[field.name]}
                onChange={handleChange}
                placeholder={field.placeholder}
                required={field.required}
                disabled={field.disabled}
              />
            )}
          </div>
        ))}
      </div>

      <div className="row mx-0 d-flex justify-content-between text-center">
        <CustomButton
          buttonName={'Cancel'}
          onClick={() => toggleModal()}
          buttonStyle={{ backgroundColor: 'red', color: '#fff' }}
          hoverEffect={{ backgroundColor: '#f7f7f7', color: 'red', border: '1px solid red' }}
          buttontype="button"
          className="col-5 py-3 px-3 w-md-25 w-50 mr-md-0 mr-0 my-4 btn rounded-pill font-weight-bold"
          type="button"
        />
        <CustomButton
          buttonName={btnName}
          buttontype="submit"
          className="col-5 py-3 px-3 w-md-25 w-50 my-4 btn btn-danger rounded-pill font-weight-bold"
          type="submit"
        />
      </div>
    </form>
  )
}

GoogleFormWrapper.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      placeholder: PropTypes.string,
      required: PropTypes.bool,
      type: PropTypes.string,
    })
  ).isRequired,
  btnName: PropTypes.string,
  formId: PropTypes.string.isRequired,
  redirectToWhatsApp: PropTypes.bool,
  whatsappNumber: PropTypes.string,
};

export default GoogleFormWrapper;